import { createSlice } from "@reduxjs/toolkit";

export const slice = createSlice({
  name: "mainSlice",
  initialState: {
    isDisplayHeader: true,
    isDisplayFooter: false,
    isCustomHeader: false,
    isCustomFooter: false,
    isSidebarOpened: false,
    isLoad: false,
    // Keyed holds for overlay owners that can overlap in time (the silentLogin
    // handshake and the V2 home gate). isLoad stays the legacy manually-paired
    // boolean used by the old screens; the overlay shows while either is up.
    // Each owner releases only its own key, so neither can hide the overlay out
    // from under the other — the race that a single shared boolean can't avoid.
    loaderHolds: {},
    suppressLoader: false,
    customHeaderText: "",
  },
  reducers: {
    headerDisplaying: (state, action) => {
      state.isDisplayHeader = action.payload;
    },
    footerDisplaying: (state, action) => {
      state.isDisplayFooter = action.payload;
    },
    headerCustomDisplaying: (state, action) => {
      state.isCustomHeader = action.payload;
    },
    setSidebarOpened: (state, action) => {
      state.isSidebarOpened = action.payload;
    },
    setCustomHeaderText: (state, action) => {
      state.customHeaderText = action.payload;
    },
    footerCustomDisplaying: (state, action) => {
      state.isDisplayFooter = action.payload;
      state.isCustomFooter = action.payload;
    },
    isLoadChanger: (state, action) => {
      state.isLoad = action.payload;
    },
    holdLoader: (state, action) => {
      state.loaderHolds[action.payload] = true;
    },
    // Releasing an absent key is a no-op, so every exit path can release
    // unconditionally.
    releaseLoader: (state, action) => {
      delete state.loaderHolds[action.payload];
    },
    // Opt-out for a screen that renders fully without the handshake, so the global
    // overlay shouldn't cover it (the welcome screen). Kept separate from isLoad
    // rather than having the screen force that down: isLoad belongs to
    // LayoutV2.silentLogin, and two owners fighting over one boolean is a race.
    setLoaderSuppressed: (state, action) => {
      state.suppressLoader = action.payload;
    },
  },
});

export const {
  headerDisplaying,
  footerDisplaying,
  setSidebarOpened,
  headerCustomDisplaying,
  footerCustomDisplaying,
  setCustomHeaderText,
  isLoadChanger,
  holdLoader,
  releaseLoader,
  setLoaderSuppressed,
} = slice.actions;

export const selectAnyLoaderHold = (state) => Object.keys(state.mainSlice.loaderHolds).length > 0;

export default slice.reducer;
